/**
 * Copyright Warner Bros. Entertainment, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Warner Bros. Entertainment, Inc. and its suppliers, if any.
 * The intellectual and technical concepts contained herein are
 * proprietary to Warner Bros. Entertainment, Inc. and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in process,
 * and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * unlawful and strictly forbidden unless prior written permission is
 * obtained from Warner Bros. Entertainment, Inc.
 */

import Moment from 'moment';

// TODO: Eventually we can move all title constants here
export const TitleConstants = {
    RELEASE: {
        DATE_TYPES: {
            FULL: {id: 0, name: 'Full'},
            MONTH_YEAR: {id: 1, name: 'Month Year'},
            SEASON_YEAR: {id: 2, name: 'Season Year'},
            YEAR: {id: 3, name: 'Year'},
            TBA: {id: 4, name: 'TBA'},
            DISPLAY_NAME: {id: 5, name: 'Display Name'},
        },
    }
};

export const isEpisode = (serieMap) => {
    return Boolean(serieMap?.size === 2);
};

export const isEpisodeFromMiniseries = (serieMap) => {
    return Boolean(serieMap?.size === 1);
};

export const isSerie = (serieMap) => {
    return Boolean(serieMap?.size === 0);
};

export const FormatTitleReleaseDate = function(title, messages, includeWeekday = false, invalidValue = '-', ) {
    if (!title || !messages) {
        return invalidValue;
    }

    const titleObj = title.toJS();
    // Handle case when title arg is a release object type with missing fields
    if (titleObj.titleReleaseDateType === undefined && titleObj.dateType !== undefined) {
        titleObj.titleReleaseDateType = titleObj.dateType;
    }
    if (titleObj.titleReleaseDate === undefined && titleObj.date !== undefined) {
        titleObj.titleReleaseDate = titleObj.date;
    }
    if (titleObj.titleReleaseDateDisplayName === undefined && titleObj.seasonDisplayName !== undefined) {
        titleObj.titleReleaseDateDisplayName = titleObj.seasonDisplayName;
    }

    if ((!titleObj.titleReleaseDate || !Moment(titleObj.titleReleaseDate).isValid()) && ![TitleConstants.RELEASE.DATE_TYPES.TBA.id, TitleConstants.RELEASE.DATE_TYPES.DISPLAY_NAME.id].includes(titleObj.titleReleaseDateType)) {
        return invalidValue;
    }

    let releaseDate = titleObj.titleReleaseDate;
    let momentReleaseDate = Moment(releaseDate);
    let returnVal = momentReleaseDate.format('MMMM DD, YYYY');

    switch (titleObj.titleReleaseDateType) {
    case TitleConstants.RELEASE.DATE_TYPES.FULL.id:
        let prepend = '';
        if (includeWeekday) {
            prepend = 'dddd, ';
        }

        returnVal = momentReleaseDate.format(`${prepend}MMMM DD, YYYY`);
        break;

    case TitleConstants.RELEASE.DATE_TYPES.MONTH_YEAR.id:
        returnVal = momentReleaseDate.format('MMMM YYYY');
        break;

    case TitleConstants.RELEASE.DATE_TYPES.SEASON_YEAR.id:
        let month = momentReleaseDate.format('MM');

        let season;
        switch (month) {
        case '12':
        case '01':
            season = messages['date-format-season-0'];
            break;
        case '04':
            season = messages['date-format-season-1'];
            break;
        case '06':
        case '07':
            season = messages['date-format-season-2'];
            break;
        case '09':
        case '10':
            season = messages['date-format-season-3'];
            break;
        default:
            season = messages['date-format-season-default'];
            break;
        }
        returnVal = season + momentReleaseDate.format(' YYYY');
        break;

    case TitleConstants.RELEASE.DATE_TYPES.YEAR.id:
        returnVal = momentReleaseDate.format('YYYY');
        break;

    case TitleConstants.RELEASE.DATE_TYPES.TBA.id:
        returnVal = messages['date-format-TBA'];
        break;

    case TitleConstants.RELEASE.DATE_TYPES.DISPLAY_NAME.id:
        returnVal = titleObj.titleReleaseDateDisplayName;
        break;
    }

    return returnVal || '-';
};
